/* 
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {ChangeEvent} from 'react';

//This function will handle the event on selection of dropdown
export const onHandleChange = ({setSelected, onChange, options}, key?: any) => {
  return function({target: {value}}: ChangeEvent<HTMLSelectElement>) {
    const matchIndex = options?.findIndex(({value: optionValue}: {value: string}) =>
      optionValue.toLocaleLowerCase() === value.toLocaleLowerCase());
    const {label, value: matchValue} = options?.[matchIndex];
    setSelected(label);
    onChange?.(matchValue, key);
  };
};
